import React, { useState } from 'react';
import OTPInput, { ResendOTP } from "otp-input-react"; 

export const OtpComponent = ({otp,setOtp}) => {

    return (
        <OTPInput 
        style={{justifyContent:'center'}}
        value={otp} 
        onChange={setOtp} 
        autoFocus 
        OTPLength={6} 
        otpType="number" 
        placeholder={["","","","","",""]}
        disabled={false} />
    );
}

